module.exports = __webpack_public_path__ + "static/media/2.12e52263.png";